import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles/styles.module.scss';

import CardImage from '../CardImage';
import TrailUgcCardContent from '../TrailUgcCardContent';
import { getFormattedTrackUrls, getTrackActivity } from '../../../utils/track_helpers';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

class TrailTrackResultCard extends React.Component {
  nameLinkSettings() {
    if (this.props.includeTrailName) {
      return {
        link: `/explore/recording/${this.props.track.slug}`,
        name: this.props.track.name,
        verb: StringConstantsMixin.strings.RECORDED
      };
    }

    return null;
  }

  render() {
    const staticMapUrl = `/api/alltrails/maps/${this.props.track.id}/static_map?size=521x217&key=` + `3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i`;
    let setOrSuggest = null;
    let removeBtn = null;
    if (this.props.adminOrPendingOwner) {
      setOrSuggest = StringConstantsMixin.strings.SET_AS_ROUTE;
      if (this.props.adminUser) {
        removeBtn = (
          <a className="link" onClick={this.props.onRemoveTrack}>
            Remove
          </a>
        );
      }
    } else if (this.props.userId) {
      setOrSuggest = StringConstantsMixin.strings.SUGGEST_AS_ROUTE_LOWER;
    }
    let deleteTrackBtn;
    if (this.props.adminUser || this.props.track.user.id == this.props.userId) {
      deleteTrackBtn = (
        <a className="link" onClick={this.props.onDeleteTrack}>
          Delete
        </a>
      );
    }

    const setTrackAsVerifiedRoute = setOrSuggest && (
      <a className="link" onClick={this.props.onSetTrackAsVerifiedRoute}>
        {setOrSuggest}
      </a>
    );
    const { localizedUrl } = getFormattedTrackUrls(this.props.track, this.props.context);
    return (
      <div className={styles.container}>
        <TrailUgcCardContent
          adminUser={this.props.adminUser}
          className={styles.content}
          context={this.props.context}
          created_at={this.props.track.created_at}
          item={this.props.track}
          tagNames={[getTrackActivity(this.props.track)]}
          nameLinkSettings={this.nameLinkSettings()}
        />
        <a href={localizedUrl} target="_blank">
          <CardImage className={styles.image} url={staticMapUrl} title={this.props.track.name} darker={false} noBackground />
        </a>
        <div className={styles.setOrSuggest}>{setTrackAsVerifiedRoute}</div>
        <div className={styles.setOrSuggest}>{removeBtn}</div>
        <div className={styles.setOrSuggest}>{deleteTrackBtn}</div>
      </div>
    );
  }
}

TrailTrackResultCard.propTypes = {
  adminOrPendingOwner: PropTypes.bool,
  adminUser: PropTypes.bool,
  context: PropTypes.shape({
    displayMetric: PropTypes.bool,
    languageRegionCode: PropTypes.string
  }),
  idx: PropTypes.number,
  onSetTrackAsVerifiedRoute: PropTypes.func,
  onRemoveTrack: PropTypes.func,
  track: PropTypes.object.isRequired,
  userId: PropTypes.number
};

export default TrailTrackResultCard;
